var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_2596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0859 15.7869C30.5048 15.0337 34.634 12.5134 33.2576 4.69197C32.1966 -0.377497 26.9778 0.0860029 25.0279 3.90983C22.103 10.196 24.1389 10.8622 21.8736 13.7012C19.8663 15.6131 18.1458 7.50192 14.5901 13.0349C13.6725 14.6861 15.0202 16.627 14.0166 18.394C11.7226 19.6686 9.3999 16.3662 6.93384 16.1635C3.8656 15.2944 0.0231318 17.3801 0.223858 20.7694C0.74001 26.65 6.36034 26.679 10.1168 29.8655C11.7513 31.5747 12.4395 33.9211 12.7836 36.2675C16.2533 47.4493 25.9741 34.4715 28.0101 33.7183C31.3651 32.0092 33.487 36.9338 36.9854 36.4703C40.9712 36.6731 42.7204 32.4727 41.6308 29.4889C40.9139 26.5921 36.1825 24.9409 37.6449 23.2897C38.878 22.073 40.7705 22.1889 42.0609 20.8274C43.4086 19.5238 43.38 16.8008 41.0859 15.7869Z",
    fill: "#38C1ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7847 9.87828C36.9567 6.57588 41.258 1.85403 45.1291 2.69411C49.8892 4.66396 38.2758 12.6882 36.7847 9.87828ZM38.5052 8.22708C38.7919 7.4739 39.2794 6.72072 39.5948 6.28619C39.1551 6.82694 38.7919 7.43528 38.5052 8.11121C38.5052 8.14983 38.5052 8.18846 38.5052 8.22708Z",
    fill: "#38C1ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8157 2.31704C18.0023 3.18609 23.4506 9.53017 13.0988 7.27064C9.14166 6.45952 8.82623 1.65077 13.8157 2.31704ZM12.2099 5.098C11.7224 4.80832 11.7798 4.31586 11.8084 4.17102C12.1334 4.01652 12.4584 3.9103 12.7834 3.85237C12.7643 3.85237 12.7356 3.85237 12.6974 3.85237C11.493 3.76546 11.5504 4.75038 12.2099 5.098Z",
    fill: "#38C1ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03778 39.2813C-0.435541 39.2234 2.89078 32.0682 6.9053 32.1551C8.71183 32.271 6.01637 39.1365 4.03778 39.2813ZM4.81202 34.4726C4.38189 34.936 4.09513 35.4864 3.86573 36.0658C4.12381 35.5154 4.41056 34.965 4.81202 34.4726ZM3.92308 37.6011C3.52163 37.1666 3.72235 36.79 3.69368 36.5583C3.65544 36.7128 3.61721 36.8769 3.57898 37.0507C3.72235 37.4563 3.75103 37.6301 3.92308 37.6011Z",
    fill: "#38C1ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_2596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintIcon);
export default __webpack_public_path__ + "static/media/PaintIcon.a1220bc5e1f2a1b43012d9a3ab5fe34b.svg";
export { ForwardRef as ReactComponent };